// extracted by mini-css-extract-plugin
module.exports =  {"productName":"productName__ZPKko","seoUrl":"seoUrl__MA4-h","shortDescription":"shortDescription__J4HTM","suffix":"suffix__xtSP-"};